import * as React from 'react';
import { Menu, MenuButton } from '@headlessui/react';
import { memo } from "react";
import IconFontAwesome from "./iconFontAwesome";

type Props = Readonly<{
	children?: React.ReactNode
	disabled?: boolean
}>;

function DropdownMenu({children, disabled = false, ...otherProps}: Props) {
	return (
		<Menu as="div" className="relative text-left inline-block" {...otherProps}>
			<MenuButton className="min-w-8" disabled={disabled}>
				<IconFontAwesome className="icon-ellipsis-vertical"/>
			</MenuButton>
			{children}
		</Menu>
	)
}

export default memo(DropdownMenu);
